<div class="relations-list" #list>
  <app-relation-card
    [relation]="relation"
    *ngFor="let relation of relations | relationsSortBy: sortOrder: limit"
  ></app-relation-card>
</div>
